var video_viewer_default = {
  "video_player": "_--r3B",
  "videoOverlay": "I4VOp",
  "video_container": "ah55f"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
